import React, { createContext, useContext, useState } from 'react';

const PaymentContext = createContext();

export const usePayment = () => {
  return useContext(PaymentContext);
};

export const PaymentProvider = ({ children }) => {
  const [cardNumber, setCardNumber] = useState('');
  const [cvv, setCvv] = useState('');
  const [expirationDate, setExpirationDate] = useState('');
  const [cardName, setCardName] = useState('');
  const [email, setEmail] = useState('');

  return (
    <PaymentContext.Provider
      value={{
        cardNumber,
        setCardNumber,
        cvv,
        setCvv,
        expirationDate,
        setExpirationDate,
        cardName,
        setCardName,
        email,
        setEmail,
      }}
    >
      {children}
    </PaymentContext.Provider>
  );
};
